import { CSSProperties, ReactNode } from "react";
import { Colors } from "../../../utils/colors";

type FoldHeaderTextProps = {
  children: ReactNode;
  isDesktopSize: boolean;
  addGradient?: boolean;
  textStyles?: CSSProperties;
};

// Standard Header Text for all landing page folds
export const FoldHeaderText = (props: FoldHeaderTextProps) => {
  const { children, isDesktopSize, addGradient, textStyles } = props;

  const styles = {
    headerText: {
      fontSize: isDesktopSize ? 64 : 48,
      fontWeight: 500,
      letterSpacing: "-0.5px",
      color: Colors.WHITE,
      ...(addGradient
        ? {
            backgroundImage:
              "linear-gradient(to bottom, #FFFFFF 4.5%, #999999 104.4%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }
        : {}),
      ...textStyles,
    },
  };

  return <h2 style={styles.headerText}>{children}</h2>;
};
